import React from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";

export type FileTypeConfig = { icon: React.ReactNode; color: string };

export const FILE_TYPE_CONFIG: Record<string, FileTypeConfig> = {
  PDF: { icon: React.createElement(PictureAsPdfIcon), color: "#d32f2f" },
  WORD: { icon: React.createElement(DescriptionIcon), color: "#1565c0" },
  PPT: { icon: React.createElement(SlideshowIcon), color: "#e65100" },
  MP4: { icon: React.createElement(OndemandVideoIcon), color: "#6a1b9a" },
};

const DEFAULT_FILE_CONFIG: FileTypeConfig = {
  icon: React.createElement(DescriptionIcon),
  color: "#616161",
};

export const getFileConfig = (fileType: string): FileTypeConfig =>
  FILE_TYPE_CONFIG[fileType.toUpperCase()] ?? DEFAULT_FILE_CONFIG;

export const formatDate = (dateString?: string): string => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};
